import React from "react";
import {
  Wrench,
  Dog,
  Droplets,
  Sparkles,
  Shield,
  Sofa,
  Wind,
  Lightbulb,
  Zap,
  Layers,
  Eraser,
  ScanLine,
  Sprout,
} from "lucide-react";

const addons = [
  { name: "Engine Bay Detail", price: "$75", Icon: Wrench },
  { name: "Pet Hair Removal", price: "$75", Icon: Dog },
  { name: "Fabric Seat Cleaning", price: "$85", Icon: Sofa },
  { name: "Odour Elimination", price: "$75", Icon: Wind },
  { name: "Sand & Dry Grass Removal", price: "$75", Icon: Sprout },
  { name: "Clay Bar Treatment", Icon: Layers },
  { name: "Iron Decontamination", Icon: Eraser },
  { name: "Leather Conditioning", Icon: Sparkles },
  { name: "Headlight Restoration", Icon: Lightbulb },
  { name: "Ceramic Spray Protection", Icon: Shield },
  { name: "Trim Restoration", Icon: Zap },
  { name: "Scratch Reduction", Icon: ScanLine },
];

export default function AddOns() {
  return (
    <section
      data-testid="addons-section"
      className="section bg-[color:var(--bg)]"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col gap-6 lg:grid lg:grid-cols-12 lg:items-end mb-12">
          <div className="col-span-12 lg:col-span-8">
            <div className="flex items-center gap-3 mb-6 reveal">
              <span className="diamond-divider" />
              <span className="overline">Add-On Services</span>
            </div>
            <h2 className="reveal font-display tracking-tight text-neutral-900 text-4xl md:text-5xl">
              Tailor every detail
              <span className="text-neutral-500 font-light italic"> to your vehicle.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-neutral-200">
          {addons.map((a) => (
            <div
              key={a.name}
              data-testid={`addon-${a.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-white p-6 md:p-7 flex flex-col gap-4 group hover:bg-neutral-50 transition-colors reveal"
            >
              <div className="flex items-start justify-between">
                <a.Icon
                  size={20}
                  strokeWidth={1.5}
                  className="text-[color:var(--accent)] group-hover:scale-110 transition-transform"
                />
                {a.price && (
                  <span className="text-[color:var(--accent)] text-xs tracking-wider font-mono">
                    from {a.price}
                  </span>
                )}
              </div>
              <div className="font-display text-neutral-900 text-base md:text-lg font-medium leading-tight">
                {a.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
